import colors from './colors';

export { colors };

export default { colors };
